import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { Component } from "react";
import { connect } from "react-redux";

import { reportError } from "store/error/actions";
import { store } from "store/configureStore";

import { appInsights } from "App/AI/AppInsights";

import { createJavascriptError } from "utils/error";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    componentDidCatch(error, info) {
        const { dispatch } = this.props;
        const { state, onError } = this.props;

        const errorData = createJavascriptError({ error, info, state });

        this.setState({ hasError: true, error: errorData });

        dispatch(reportError(errorData));

        appInsights.trackException({
            exception: error,
            severityLevel: SeverityLevel.Error,
            properties: {
                ...info,
                ...error,
                userName: store?.getState()?.vdsmUser?.name,
            },
        });

        onError && onError(errorData);
    }

    render() {
        return this.state.hasError ? (
            <div className="flex-column" style={{ padding: 20 }}>
                <h2>Something went wrong.</h2>
                <pre style={{ whiteSpace: "pre-line" }}>
                    {Object.keys(this.state.error).map((key) => (
                        <div key={key}>
                            <br />
                            <div style={{ color: "red", fontWeight: "bold" }}>{key.substr(5)}</div>
                            <div>{this.state.error[key]}</div>
                        </div>
                    ))}
                </pre>
            </div>
        ) : (
            this.props.children
        );
    }
}

function mapStateToProps(state) {
    return { state };
}

export default connect(mapStateToProps)(ErrorBoundary);
